// extracted by mini-css-extract-plugin
module.exports = {"carousel-image":"CarouselMobile_carousel-image__JNkWi"};